/* [BD feat] <bd-read-more> — "Weiterlesen / Weniger anzeigen" toggle for clamped text.
   Shared by sections/bd-story-details-panel.liquid (PDP story text) and
   sections/bd-seo-category-text.liquid (collection SEO text). The clamp itself (max-height +
   overflow) lives in each section's CSS; this element only flips .is-expanded and swaps the
   button label.
   Optional: when the element contains a [data-bd-read-more-content] node, it also sets
   .is-short while that node's text fits inside its clamp, so the section's CSS can hide the
   toggle for short texts. Re-measured on resize (width changes re-wrap the text). */
class BdReadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-bd-read-more-toggle]');
    this.label = this.querySelector('[data-bd-read-more-label]');
    this.content = this.querySelector('[data-bd-read-more-content]');
    this.moreText = this.label ? this.label.textContent : '';
    this.lessText = this.dataset.lessText || this.moreText;
    this.button?.addEventListener('click', () => this.toggle());

    if (this.content && 'ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
      this.resizeObserver.observe(this.content);
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  updateOverflow() {
    if (this.classList.contains('is-expanded')) return;
    const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
    this.classList.toggle('is-short', !overflowing);
  }

  toggle() {
    const expanded = this.classList.toggle('is-expanded');
    this.button.setAttribute('aria-expanded', String(expanded));
    if (this.label) this.label.textContent = expanded ? this.lessText : this.moreText;

    // Collapsing a long text can leave the viewport far below the (now short) block —
    // bring its top back into view.
    if (!expanded && this.getBoundingClientRect().top < 0) {
      this.scrollIntoView({ block: 'start' });
    }
  }
}

if (!customElements.get('bd-read-more')) {
  customElements.define('bd-read-more', BdReadMore);
}
